import { toProjectType } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { useProject } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/project/index.tsx';

export function useProjectType() {
	// project type (software, service desk, etc) so we can target JSW projects
	// we do not look at whether the project is still loading
	// if data is undefined we will return undefined
	const { data: project } = useProject();
	const projectType = toProjectType(project?.type);

	return { projectType };
}
